interface AppRoutes {
	schedule: string
	files: string
}

const ROUTES: AppRoutes = {
	schedule: '/horarios',
	files: '/',
}

export default ROUTES
